import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import { observationLookup } from '../../../../actions/api';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, SelectInput, DateInput, SwitchInput, TextInput } from '../../../Form';
import FormMultiSelectInput from '../../../FormMultiSelectInput';
import moment from 'moment';
import DataFilter from '../../../StationFilter';

@inject('transferStore', 'parameterStore', 'stationStore')
@observer
class TableAdd extends Component {
    static propTypes = {
        route: PropTypes.shape().isRequired,
        transferStore: PropTypes.object.isRequired,
        parameterStore: PropTypes.object.isRequired,
    }

    static contextTypes = {
        router: PropTypes.shape().isRequired,
        notify: PropTypes.shape().isRequired,
    }

    @observable item = {
        source_table: '',
        destination_table: '',
        date_from: moment().subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
        date_to: moment().format('YYYY-MM-DDTHH:mm:ss'),
        filter_duplicate: false,
        delete_from_source: true,
        stations: [],
        remark: '',
    };

    @observable multiStationOptions = [];
    @observable multiParameterOptions = [];

    @observable tablesList = [];

    slug = '/tools/data_movement';
    title = 'Add Movement';

    constructor(props) {
        super(props);
        this.handleSave = this.handleSave.bind(this);
    }

    optionsReducer = options => options.reduce((acc, item) => {
        if (item.value === true) acc.push(item.id);
        return acc;
    }, []);

    componentDidMount() {
        observationLookup.fetchAll().then(res => {
            if (res) this.tablesList = res;
        });
        const { stationStore, parameterStore } = this.props;
        if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
        if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();
        this.populateOptions();
    }

    populateOptions = () => {
        const { stationStore, parameterStore } = this.props;
        if (stationStore.items.length === 0 || parameterStore.items.length === 0) {
            setTimeout(() => {
                this.populateOptions();
            }, 300)
        } else {
            this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
            this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, code: item.code }));
        }
    };

    @action onParameterChange = (e) => { this.item.parameter_id = e.target.value; }
    @action onSourceTableChange = (e) => { this.item.source_table = e.target.value; }
    @action onDestinationTableChange = (e) => { this.item.destination_table = e.target.value; }

    handleSave(e) {
        e.preventDefault();
        const { notify } = this.context;
        const { source_table, destination_table } = this.item;
        const { transferStore } = this.props;

        if (source_table && source_table !== '' && destination_table && destination_table !== '') {

            const payload = {
                status: 0,
                source_table,
                destination_table,
                date_from: this.item.date_from,
                date_to: this.item.date_to,
                // stations: this.optionsReducer(this.multiStationOptions),
                stations: toJS(this.item.stations),
                parameters: this.optionsReducer(this.multiParameterOptions),
                filter_duplicate: this.item.filter_duplicate ? 1 : 0,
                delete_from_source: this.item.delete_from_source ? 1 : 0,
                remark: this.item.remark,
            };

            transferStore.createItem(payload).then((res) => {
                if (!res.error) {
                    notify.success({ message: 'Added successfully' });
                    transferStore.fetchItems();
                    this.context.router.push(this.slug);
                } else {
                    notify.error({ message: res.message });
                }
            });
        } else {
            alert('Required parameters not filled!');
        }
    }

    @action onStationOptionClicked = item => item.value = !item.value;
    @action onParameterOptionClicked = item => item.value = !item.value;

    render() {
        const { parameterStore, transferStore, stationStore } = this.props;

        if (transferStore.isLoading) return <Spinner />;

        return (
            <Modal title={this.title} slug={this.slug} isSaving={transferStore.isSaving} handleSave={this.handleSave}>
                <div>
                    <DataFilter onSelectedStationIdsChange={s => this.item.stations = s} />
                    <Form>
                        <FormBody>
                            {/* <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onStationOptionClicked} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} /> */}
                            <FormMultiSelectInput id='parameter-multi-select' label='Parameters' options={this.multiParameterOptions} optionClicked={this.onParameterOptionClicked} isLoading={parameterStore.isLoading} filterOptions={parameterStore.filterParameters} />

                            <TextInput
                                label={'Remark'}
                                value={this.item.remark}
                                onChange={e => this.item.remark = e.target.value}
                            />
                            <DateInput
                                label={'Date From'}
                                type="datetime-local"
                                value={moment(this.item.date_from).format('YYYY-MM-DDTHH:mm:ss')}
                                onChange={e => this.item['date_from'] = e.target.value}
                            />
                            <DateInput
                                label={'Date To'}
                                type="datetime-local"
                                value={moment(this.item.date_to).format('YYYY-MM-DDTHH:mm:ss')}
                                onChange={e => this.item['date_to'] = e.target.value}
                            />
                            <SelectInput options={this.tablesList}
                                label={"Source Table"}
                                fields={{ label: 'name', value: 'id' }}
                                onChange={this.onSourceTableChange}
                                value={this.item.source_table} />

                            <SelectInput options={this.tablesList}
                                label={"Destination Table"}
                                fields={{ label: 'name', value: 'id' }}
                                onChange={this.onDestinationTableChange}
                                value={this.item.destination_table} />

                            <SwitchInput
                                label={"Filter duplicate"}
                                value={this.item.filter_duplicate}
                                onChange={e => this.item.filter_duplicate = !this.item.filter_duplicate}
                            />

                            <SwitchInput
                                label={"Delete from source"}
                                value={this.item.delete_from_source}
                                onChange={e => this.item.delete_from_source = !this.item.delete_from_source}
                            />

                        </FormBody>

                        <FormActions>
                            <button onClick={this.handleSave}>Save</button>
                        </FormActions>
                    </Form>
                </div>
            </Modal>
        );
    }
}

export default TableAdd;



// WEBPACK FOOTER //
// ./src/components/Tools/DataMovement/BetweenTables/TableAdd.js